export const colors = {
  green700: '#075b54',
  green500: '#51aba2',
  green300: '#ecf5f3',
  blue700: '#3d6aa8',
  blue500: '#87b7d4',
  blue300: '#e8f5f8',
  brown700: '#804817',
  brown500: '#d2aa61',
  brown300: '#fcf0da',
  red700: '#d02c28',
  red500: '#da918f',
  red300: '#f8efef',
  orange700: '#fb8355',
  orange500: '#ffb99e',
  orange300: '#ffe0d4',
  yellow700: '#fedc8c',
  yellow500: '#fcefcf',
  yellow300: '#fff9eb',
  black700: '#000000',
  black500: '#878787',
  black300: '#dddddd',
  black100: '#f5f5f5',
  ftgreen: '#94BB4E',
  ftblue: '#3AB1D7',
  ftlightblue: '#65D7E8',
  ftyellow: '#efb639',
  cbred: '#d7191c',
  cborange: '#fdae61',
  cbgreen: '#b2df8a',
  cbblue: '#1f78b4',
  cbaqua: '#80cdc1',
}
